<template>
  <div class="app-container">
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <!-- <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column> -->
      <el-table-column label="firstname" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.firstname }}
        </template>
      </el-table-column>
      <el-table-column label="lastname" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.lastname }}
        </template>
      </el-table-column>
      <el-table-column label="country" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.country }}
        </template>
      </el-table-column>
      <el-table-column label="email" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.email }}
        </template>
      </el-table-column>
      <el-table-column label="userrole" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.userrole }}
        </template>
      </el-table-column>
      <el-table-column label="twitter" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.twitter }}
        </template>
      </el-table-column>
      <el-table-column label="telegram" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.telegram }}
        </template>
      </el-table-column>
      <el-table-column label="whatsapp" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.whatsapp }}
        </template>
      </el-table-column>
      <el-table-column label="phone" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="promotePlatform" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.promotePlatform }}
        </template>
      </el-table-column>
      <el-table-column label="Created on" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.CreatedOnUtc | dateStr }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/admin/customer/affiliateProgramList",
        method: "get",
        params: this.listQuery
      }).then(response => {
        console.log(response.data);
        this.list = response.data.Data;
        this.total = response.data.Total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
